import { z } from 'zod';
import { listResponse } from '../../utils/listResponse';
import { inboxSchema } from '../models/inbox.schema';
import { listInboxesQuerySchema } from './list.schema';

export type ListInboxesQuery = {
  page?: number;
};
export const list = (query: ListInboxesQuery) => {
  return {
    method: 'GET',
    endpoint: '/inboxes',
    responseSchema: listResponse(inboxSchema),
    query: { ...query, includeTotal: true },
    querySchema: listInboxesQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
